import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  URLBuilder1hwx1b9569i61 as URLBuilder,
  takeFromkqlcz7c6dx2r as takeFrom,
} from '../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import { ParametersBuilder1ry9ntvvg567r as ParametersBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/Parameters.mjs';
import { appendAlltwnjnu28pmtx as appendAll } from '../../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { checkBuilderCapacity1h6g02949wvv as checkBuilderCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { get_ENGINE_CAPABILITIES_KEYr1fjz8liznxo as get_ENGINE_CAPABILITIES_KEY } from '../engine/HttpClientEngineCapability.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { Phases_getInstance27czzec4fvnke as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HeadersBuilder3h7sn3kkvu98m as HeadersBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import { URLBuilder2mz8zkz4u9ray as URLBuilder_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { takeFrom3rd40szpqy350 as takeFrom_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_DefaultRequest_kt__yzsodq();
  return LOGGER;
}
var LOGGER;
function defaultRequest(_this__u8e3s4, block) {
  _init_properties_DefaultRequest_kt__yzsodq();
  var tmp = Plugin_getInstance();
  return _this__u8e3s4.j5i(tmp, ($this$install) => {
    block($this$install);
    return Unit_instance;
  });
}
function mergeUrls($this, baseUrl, requestUrl) {
  if (requestUrl.f55_1 == null) {
    requestUrl.f55_1 = baseUrl.a56_1;
  }
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = requestUrl.c55_1;
  if (charSequenceLength(this_0) > 0)
    return Unit_instance;
  var resultUrl = URLBuilder(baseUrl);
  // Inline function 'kotlin.with' call
  resultUrl.f55_1 = requestUrl.f55_1;
  if (!(requestUrl.e55_1 === 0)) {
    resultUrl.k56(requestUrl.e55_1);
  }
  resultUrl.j55_1 = concatenatePath(Plugin_getInstance(), resultUrl.j55_1, requestUrl.j55_1);
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_1 = requestUrl.i55_1;
  if (charSequenceLength(this_1) > 0) {
    resultUrl.i55_1 = requestUrl.i55_1;
  }
  // Inline function 'kotlin.apply' call
  var this_2 = ParametersBuilder();
  appendAll(this_2, resultUrl.k55_1);
  var defaultParameters = this_2;
  resultUrl.x56(requestUrl.k55_1);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = defaultParameters.o4p().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    // Inline function 'kotlin.collections.component1' call
    var key = element.m3();
    // Inline function 'kotlin.collections.component2' call
    var values = element.n3();
    if (!resultUrl.k55_1.o4o(key)) {
      resultUrl.k55_1.p4p(key, values);
    }
  }
  takeFrom(requestUrl, resultUrl);
}
function concatenatePath($this, parent, child) {
  if (child.n1())
    return parent;
  if (parent.n1())
    return child;
  // Inline function 'kotlin.text.isEmpty' call
  var this_0 = first(child);
  if (charSequenceLength(this_0) === 0)
    return child;
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  var capacity = (parent.q2() + child.q2() | 0) - 1 | 0;
  checkBuilderCapacity(capacity);
  // Inline function 'kotlin.apply' call
  var this_1 = ArrayList().i2(capacity);
  var inductionVariable = 0;
  var last = parent.q2() - 1 | 0;
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this_1.j2(parent.r2(index));
    }
     while (inductionVariable < last);
  this_1.u2(child);
  return this_1.f8();
}
function DefaultRequest$Plugin$install$slambda$lambda() {
  // Inline function 'kotlin.collections.mutableMapOf' call
  return LinkedHashMap().ec();
}
function DefaultRequest$Plugin$install$slambda($plugin) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    var originalUrlString = $this$intercept.y4s_1.a5i_1.toString();
    // Inline function 'kotlin.apply' call
    var this_0 = new (DefaultRequestBuilder())();
    appendAll(this_0.y5m_1, $this$intercept.y4s_1.c5i_1);
    var userHeaders = this_0.y5m_1.j37();
    $plugin.b5n_1(this_0);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = userHeaders.o4p().p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      $l$block_0: {
        // Inline function 'kotlin.collections.component1' call
        var key = element.m3();
        // Inline function 'kotlin.collections.component2' call
        var oldValues = element.n3();
        var newValues = this_0.y5m_1.u4p(key);
        if (newValues == null) {
          this_0.y5m_1.p4p(key, oldValues);
          break $l$block_0;
        }
        if (equals(newValues, oldValues) || key === 'Cookie') {
          break $l$block_0;
        }
        this_0.y5m_1.c4q(key);
        this_0.y5m_1.p4p(key, oldValues);
        this_0.y5m_1.b4q(key, newValues);
      }
    }
    var defaultRequest = this_0;
    var defaultUrl = defaultRequest.z5m_1.j37();
    mergeUrls(Plugin_getInstance(), defaultUrl, $this$intercept.y4s_1.a5i_1);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = defaultRequest.a5n_1.r4n().p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      if (element_0.equals(get_ENGINE_CAPABILITIES_KEY())) {
        var tmp = get_ENGINE_CAPABILITIES_KEY();
        var capabilities = $this$intercept.y4s_1.f5i_1.q4n(tmp, DefaultRequest$Plugin$install$slambda$lambda);
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_1 = defaultRequest.a5n_1.k4n(get_ENGINE_CAPABILITIES_KEY()).l3().p1();
        while (_iterator__ex2g4s_1.q1()) {
          var _destruct__k2r9zo = _iterator__ex2g4s_1.r1();
          // Inline function 'kotlin.collections.component1' call
          var key_0 = _destruct__k2r9zo.m3();
          // Inline function 'kotlin.collections.component2' call
          var value = _destruct__k2r9zo.n3();
          // Inline function 'kotlin.collections.contains' call
          // Inline function 'kotlin.collections.containsKey' call
          if (!(isInterface(capabilities, KtMap()) ? capabilities : THROW_CCE()).v4(key_0)) {
            // Inline function 'kotlin.collections.set' call
            capabilities.a5(key_0, value);
          }
        }
      } else if (!$this$intercept.y4s_1.f5i_1.m4n(element_0)) {
        $this$intercept.y4s_1.f5i_1.n4n(element_0 instanceof AttributeKey() ? element_0 : THROW_CCE(), defaultRequest.a5n_1.k4n(element_0));
      }
    }
    $this$intercept.y4s_1.c5i_1.s4();
    $this$intercept.y4s_1.c5i_1.z4p(defaultRequest.y5m_1.j37());
    get_LOGGER().c4u('Applied DefaultRequest to ' + originalUrlString + '. New url: ' + $this$intercept.y4s_1.a5i_1.toString());
    return Unit_instance;
  }, 2);
}
var PluginClass;
function Plugin() {
  if (PluginClass === VOID) {
    class $ {
      constructor() {
        Plugin_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'DefaultRequest';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(DefaultRequest());
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(getKClass(DefaultRequest()), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$2 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
        tmp.c5n_1 = new (AttributeKey())(name, tmp$ret$1);
      }
      m3() {
        return this.c5n_1;
      }
      d5n(block) {
        return new (DefaultRequest())(block);
      }
      h5i(block) {
        return this.d5n(block);
      }
      e5n(plugin, scope) {
        var tmp = Phases_getInstance().i5m_1;
        scope.g5g_1.c4t(tmp, DefaultRequest$Plugin$install$slambda(plugin));
      }
      i5i(plugin, scope) {
        return this.e5n(plugin instanceof DefaultRequest() ? plugin : THROW_CCE(), scope);
      }
    }
    initMetadataForObject($, 'Plugin');
    PluginClass = $;
  }
  return PluginClass;
}
var Plugin_instance;
function Plugin_getInstance() {
  if (Plugin_instance === VOID)
    new (Plugin())();
  return Plugin_instance;
}
var DefaultRequestBuilderClass;
function DefaultRequestBuilder() {
  if (DefaultRequestBuilderClass === VOID) {
    class $ {
      constructor() {
        this.y5m_1 = new (HeadersBuilder())();
        this.z5m_1 = new (URLBuilder_0())();
        this.a5n_1 = AttributesJsFn(true);
      }
      y51() {
        return this.y5m_1;
      }
      f5n(urlString) {
        takeFrom_0(this.z5m_1, urlString);
      }
    }
    initMetadataForClass($, 'DefaultRequestBuilder');
    DefaultRequestBuilderClass = $;
  }
  return DefaultRequestBuilderClass;
}
var DefaultRequestClass;
function DefaultRequest() {
  if (DefaultRequestClass === VOID) {
    class $ {
      constructor(block) {
        Plugin_getInstance();
        this.b5n_1 = block;
      }
    }
    initMetadataForClass($, 'DefaultRequest');
    DefaultRequestClass = $;
  }
  return DefaultRequestClass;
}
var properties_initialized_DefaultRequest_kt_au5efk;
function _init_properties_DefaultRequest_kt__yzsodq() {
  if (!properties_initialized_DefaultRequest_kt_au5efk) {
    properties_initialized_DefaultRequest_kt_au5efk = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.DefaultRequest');
  }
}
//region block: exports
export {
  defaultRequest as defaultRequest2ux1d5xxixv6z,
};
//endregion

//# sourceMappingURL=DefaultRequest.mjs.map
